<nx-ng-modal-header
  [showTicket]="showTicket"
  [title]="title"
></nx-ng-modal-header>
<mat-dialog-content>
  <nx-ng-bus-e-commerce-renderer [markdown]="translatedMarkdown">
  </nx-ng-bus-e-commerce-renderer>
</mat-dialog-content>
